import React from 'react';
import SampleMessage from 'components/SampleMessage';

const ManagerPage: React.FC = () => {
  return (
    <SampleMessage api_path="manager/welcome" />
  );
};

export default ManagerPage;
